/* ==========================================================================
   Il était une fois nous : aperçu gratuit des personnages (sections/iuf2-apercu.liquid)
   - la photo est réduite dans le navigateur (envoi plus rapide, iPhone HEIC converti)
   - envoi au serveur d'aperçu, attente animée, affichage de l'image
   ========================================================================== */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const COTE_MAX = 1536;
  const MESSAGES = [
    'On dessine vos visages…',
    'On ajuste vos coiffures…',
    'On allume la lumière dorée…',
    'Encore quelques coups de pinceau…',
    'Presque prêt…',
  ];

  function init() {
    const racine = $('[data-apercu]');
    if (!racine) return;
    const serveur = (racine.dataset.serveur || '').replace(/\/$/, '');
    const form = $('[data-apercu-form]', racine);
    const fichier = $('[data-apercu-fichier]', racine);
    const miniature = $('[data-apercu-miniature]', racine);
    const invite = $('[data-apercu-invite]', racine);
    const erreur = $('[data-apercu-erreur]', racine);
    const bouton = $('[data-apercu-envoyer]', racine);
    const attente = $('[data-apercu-attente]', racine);
    const message = $('[data-apercu-message]', racine);
    const resultat = $('[data-apercu-resultat]', racine);
    let photo = null;

    const afficherErreur = (texte) => {
      erreur.textContent = texte;
      erreur.hidden = !texte;
      if (texte) erreur.scrollIntoView({ block: 'center', behavior: 'smooth' });
    };

    fichier.addEventListener('change', async () => {
      afficherErreur('');
      photo = null;
      const f = fichier.files && fichier.files[0];
      if (!f) return;
      try {
        photo = await reduire(f);
        miniature.src = URL.createObjectURL(photo);
        miniature.hidden = false;
        invite.innerHTML = '<strong>Changer de photo</strong>';
      } catch (e) {
        miniature.hidden = true;
        afficherErreur("Cette photo n'a pas pu être lue. Essayez une autre photo (JPEG ou PNG), ou une capture d'écran de celle-ci.");
      }
    });

    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      afficherErreur('');
      const d = new FormData(form);
      if (!String(d.get('prenom1') || '').trim()) return afficherErreur('Indiquez votre prénom.');
      if (!photo) return afficherErreur('Ajoutez une photo de vous deux.');
      if (!form.email.checkValidity() || !form.email.value) return afficherErreur('Indiquez une adresse email valide.');
      if (!form.consent_photo.checked) return afficherErreur("Cochez la case d'accord pour la photo : sans elle, nous ne pouvons pas créer l'aperçu.");
      if (!d.get('cf-turnstile-response')) return afficherErreur('Patientez une seconde : la vérification anti-robot se termine.');
      d.set('photo', photo, 'photo.jpg');
      // Pour Meta (API Conversions, côté serveur) : seulement si le visiteur a accepté les cookies publicitaires.
      // Le même identifiant sert au pixel du navigateur, pour que Meta ne compte pas l'aperçu deux fois.
      const idEvenement = 'apercu-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      const pubOk = await pubAutorisee();
      d.set('event_id', idEvenement);
      d.set('consent_pub', pubOk ? 'oui' : 'non');
      d.set('consent_detail', detailConsentement);
      d.set('page_url', location.href.split('#')[0]);
      if (pubOk) {
        const cookie = (nom) => (document.cookie.match('(?:^|; )' + nom + '=([^;]*)') || [])[1] || '';
        d.set('fbp', cookie('_fbp'));
        d.set('fbc', cookie('_fbc'));
      }

      bouton.disabled = true;
      form.hidden = true;
      attente.hidden = false;
      let i = 0;
      message.textContent = MESSAGES[0];
      const minuteur = setInterval(() => {
        i = Math.min(i + 1, MESSAGES.length - 1);
        message.textContent = MESSAGES[i];
      }, 7000);
      attente.scrollIntoView({ block: 'center', behavior: 'smooth' });

      try {
        const rep = await fetch(serveur + '/apercu', { method: 'POST', body: d });
        const r = await rep.json().catch(() => ({}));
        if (!rep.ok || !r.image) throw new Error(r.erreur || 'La création a échoué. Réessayez dans quelques minutes.');
        const img = $('[data-apercu-image]', racine);
        img.src = r.image;
        ['contextmenu', 'dragstart'].forEach((e) => img.addEventListener(e, (ev) => ev.preventDefault()));
        $('[data-apercu-email-info]', racine).textContent = r.emailEnvoye
          ? 'Nous vous l’avons aussi envoyée par email (pensez à regarder les indésirables).'
          : '';
        attente.hidden = true;
        resultat.hidden = false;
        resultat.scrollIntoView({ block: 'start', behavior: 'smooth' });
        // Compté comme « Lead » chez Meta par le serveur (API Conversions) et, en secours, par le pixel personnalisé
        // « Meta - aperçu demandé » (Shopify > Événements clients) ; même event_id pour éviter le double comptage.
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('apercu_demande', { event_id: idEvenement });
      } catch (e) {
        attente.hidden = true;
        form.hidden = false;
        afficherErreur(e.message || 'La création a échoué. Réessayez dans quelques minutes.');
        if (window.turnstile) window.turnstile.reset();
      } finally {
        clearInterval(minuteur);
        bouton.disabled = false;
      }
    });
  }

  // Le visiteur a-t-il accepté les cookies publicitaires (bandeau Shopify) ? L'outil de consentement de Shopify
  // n'est pas chargé d'office sur nos pages : on le charge, et sans réponse en 3 s on considère que non.
  // detailConsentement : ce qui a été lu, transmis au serveur pour son journal (aucune donnée personnelle).
  let detailConsentement = '-';
  function pubAutorisee() {
    return new Promise((ok) => {
      const lire = () => {
        const cp = window.Shopify && Shopify.customerPrivacy;
        if (cp && typeof cp.marketingAllowed === 'function') {
          const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
          detailConsentement = c ? 'outil:marketing=' + c.marketing : 'outil';
          return ok(!!cp.marketingAllowed());
        }
        // Secours : le choix du bandeau est enregistré par Shopify dans le cookie « _tracking_consent ».
        const brut = (document.cookie.match('(?:^|; )_tracking_consent=([^;]*)') || [])[1];
        let texte = '';
        try { texte = brut ? decodeURIComponent(brut) : ''; } catch (e) { texte = ''; }
        const oui = /"m"\s*:\s*("1"|true)/.test(texte);
        detailConsentement = brut ? 'cookie:marketing=' + (oui ? 'oui' : 'non') : 'ni-outil-ni-cookie';
        ok(oui);
      };
      // L'outil peut exister à moitié (sans ses fonctions) : on ne s'en sert que s'il est complet.
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.marketingAllowed === 'function') return lire();
      if (!(window.Shopify && Shopify.loadFeatures)) return lire();
      setTimeout(() => { if (detailConsentement === '-') lire(); }, 5000);
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => lire());
    });
  }

  // Réduit la photo (côté le plus long : 1536 px) et la convertit en JPEG.
  function reduire(f) {
    return new Promise((ok, ko) => {
      const img = new Image();
      const url = URL.createObjectURL(f);
      img.onload = () => {
        const k = Math.min(1, COTE_MAX / Math.max(img.naturalWidth, img.naturalHeight));
        const c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k);
        c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob((b) => (b ? ok(b) : ko(new Error('conversion'))), 'image/jpeg', 0.9);
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        ko(new Error('lecture'));
      };
      img.src = url;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
